import { Flex, Spinner, Text, VStack } from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import { useRole } from '../../providers/RoleProvider'
import AddPatientPanel from './AddPatientPanel'
import QueueList from './QueueList'
import messages from './messages'
import PageHeader from '../../components/InternalAppShell/PageHeader'
import { QueueListIcon } from '@heroicons/react/24/outline'
import InternalAppShell from '../../components/InternalAppShell'
import TodaysAppointments from './TodaysAppointments'
import { useAccount } from '../../client/modules/account/AccountProvider'
import { normalizeAppointmentSettings } from '../../utils/appointmentUtils'

export default function SecretaryDashboard() {
  const { doctorId, loading } = useRole()
  const { formatMessage } = useIntl()
  const account = useAccount()

  if (loading || account.loading) {
    return (
      <Flex h="100vh" align="center" justify="center">
        <Spinner size="xl" color="blue.500" />
      </Flex>
    )
  }

  if (!doctorId) {
    return (
      <Flex h="100vh" align="center" justify="center">
        <Text color="red.500">
          {formatMessage(messages.unableToLoadSession)}
        </Text>
      </Flex>
    )
  }

  return (
    <InternalAppShell
      role="secretary"
      contentMode="wide"
      title={formatMessage(messages.todaysQueue)}
    >
      <VStack spacing={6} maxW="1240px" mx="auto" align="stretch">
        <PageHeader
          title={formatMessage(messages.todaysQueue)}
          description={formatMessage({ id: 'page.queueDescription' })}
          icon={QueueListIcon}
        />
        <TodaysAppointments
          doctorId={doctorId}
          settings={normalizeAppointmentSettings(account.appointmentSettings)}
        />
        <AddPatientPanel doctorId={doctorId} />
        <QueueList doctorId={doctorId} />
      </VStack>
    </InternalAppShell>
  )
}
